module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    ref: "bg",
    staticClass: "widget__background"
  }), _c('div', {
    staticClass: "widget__content"
  }, [_c('div', {
    staticClass: "widget__text"
  }, [(_vm.content.title) ? _c('div', {
    ref: "title",
    staticClass: "widget-title"
  }, [_vm._v(_vm._s(_vm.content.title))]) : _vm._e(), (_vm.content.description) ? _c('div', {
    directives: [{
      name: "md",
      rawName: "v-md",
      value: (_vm.content.description),
      expression: "content.description"
    }],
    ref: "content",
    staticClass: "widget-description markdown-container"
  }) : _vm._e()]), _c('div', {
    staticClass: "widget__slider slider"
  }, [_c('div', {
    staticClass: "slider-arrows-container"
  }, [_c('div', {
    ref: "arrows",
    staticClass: "slider-arrows"
  }, [_c('button', {
    staticClass: "slider-arrows__item slider-arrow",
    attrs: {
      "type": "button",
      "disabled": _vm.scroll <= _vm.offset
    },
    on: {
      "click": function($event) {
        _vm.changeSlide(-1)
      }
    }
  }, [_c('img', {
    staticClass: "slider-arrow__static",
    attrs: {
      "src": require("../../../assets/arrow-prev-blue.svg")
    }
  }), _c('img', {
    staticClass: "slider-arrow__hover",
    attrs: {
      "src": require("../../../assets/arrow-prev.svg")
    }
  })]), _c('button', {
    staticClass: "slider-arrows__item slider-arrow",
    attrs: {
      "type": "button",
      "disabled": _vm.scroll >= _vm.maxScroll - _vm.offset
    },
    on: {
      "click": function($event) {
        _vm.changeSlide(1)
      }
    }
  }, [_c('img', {
    staticClass: "slider-arrow__static",
    attrs: {
      "src": require("../../../assets/arrow-next-blue.svg")
    }
  }), _c('img', {
    staticClass: "slider-arrow__hover",
    attrs: {
      "src": require("../../../assets/arrow-next.svg")
    }
  })])])]), _c('div', {
    staticClass: "slider-container"
  }, [_c('div', {
    ref: "scrollable",
    staticClass: "slider-scrollable",
    on: {
      "scroll": _vm.getScroll
    }
  }, [_c('div', {
    ref: "track",
    staticClass: "slider-track"
  }, _vm._l((_vm.content.items.media), function(slide, index) {
    return _c('div', {
      key: index,
      ref: "slides",
      refInFor: true,
      staticClass: "slide"
    }, [_c('img', {
      ref: "img",
      refInFor: true,
      attrs: {
        "src": slide.url,
        "alt": "slider image"
      }
    })])
  }))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6129d8aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/post/widgets/slider.vue
// module id = 489
// module chunks = 0